function copyToClipBoard(fieldId) {
    // Get text
    var txt = fieldId;
    // Create new element
    var el = document.createElement('textarea');
    // Set value (string to be copied)
    el.value = txt;
    // Set non-editable to avoid focus and move outside of view
    el.setAttribute('readonly', '');
    el.style = {
        position: 'absolute',
        left: '-9999px'
    };
    document.body.appendChild(el);
    // Select text inside element
    el.select();
    // Copy text to clipboard
    document.execCommand('copy');
    // Remove temporary element
    document.body.removeChild(el);
    return true;
}

// init base functions
//openLoading();
$(window).on('load', function () {
    classOnBody($('main').attr('id'));
     scrollDirection();
    initGettersAndSetters();
    changeTouchClickText();
    //closeLoading();
    $('body').removeAttr('style');
});
$(window).on('hashchange', function () {
    initGettersAndSetters();
});

// components
if ($('.liSelect').length) {
    $('.liSelect select').on('focusin', function () {
        $(this).parent('.liSelect').addClass('is-active');
    });
    $('.liSelect select').on('focusout', function () {
        $(this).parent('.liSelect').removeClass('is-active');
    });
}
if ($('.l-userConnected').length) {
    limitCaracters($('.l-userConnected .userName'), 20);
}

// nav
if ($('.l-nav').length) {
    // vars
    var nav_scrollInit = 0;
    var nav_classActive = 'is-active';
    var nav_el = {
        body: $('body'),
        hamburguer: $('.c-hamburguer'),
        mask: $('.l-nav__maskMenu'),
        nav: $('.l-nav'),
        navContentHero: $('.l-nav__contentHero'),
        liWithOneLevelSubMenu: $('.liWithOneLevelSubMenu > a'),
        liWithTwoLevelsSubMenu: $('.liWithTwoLevelsSubMenu > a'),
        liWithoutSubMenu: $('.liWithoutSubMenu > a'),
        firstSubMenu: $('.firstSubMenu'),
        secondSubMenu: $('.secondSubMenu'),
        openSecondSubMenu: $('.openSecondSubMenu'),
    };

    // functions
    function showMask() {
        nav_el.mask.addClass(nav_classActive);
    }
    function hideMask() {
        nav_el.mask.removeClass(nav_classActive);
    }
    function closeAllSubMenus() {
        nav_el.liWithOneLevelSubMenu.parent('li').removeClass(nav_classActive);
        nav_el.liWithTwoLevelsSubMenu.parent('li').removeClass(nav_classActive);
    }
    function overflowBlocked() {
        nav_el.body.addClass('u-overflowBlocked');
    }
    function overflowFree() {
        nav_el.body.removeClass('u-overflowBlocked');
    }
    function closeNavContent() {
        nav_el.navContentHero.removeClass(nav_classActive);
    }
    function openNavContent() {
        nav_el.navContentHero.addClass(nav_classActive);
    }
    function inactiveHamburguer() {
        nav_el.hamburguer.removeClass(nav_classActive);
    }
    function activeHamburguer() {
        nav_el.hamburguer.addClass(nav_classActive);
    }

    function closeAllMenuItens() {
        hideMask();
        closeAllSubMenus();
        overflowFree();
        closeNavContent();
        inactiveHamburguer();
    }
    function openAllMenuItens() {
        showMask();
        overflowBlocked();
        openNavContent();
        activeHamburguer()
    }

    // effect on scroll
    $(window).on('scroll', function(event) {
        var scrollBody = $(this).scrollTop();

        // scroll up to 99
        if (scrollBody > 99) {
            nav_el.nav.addClass('scrolled');
        } else {
            nav_el.nav.removeClass('scrolled');
        }

        // middle class
        if (scrollBody > 600) {
            nav_el.nav.addClass('hidden');
            nav_el.nav.addClass('scrolledMiddle');
        } else {
            nav_el.nav.removeClass('hidden');
            nav_el.nav.removeClass('scrolledMiddle');
        }

        // scroll up or down
        if (scrollBody < nav_scrollInit) {
            nav_el.nav.removeClass('hidden');
            nav_el.nav.addClass('scrolledUp');
            nav_el.nav.removeClass('scrolledDown');
        } else {
            nav_el.nav.removeClass('scrolledUp');
            nav_el.nav.addClass('scrolledDown');
        }

        // close menus on hidden nav
        if(nav_el.nav.hasClass('hidden')) {
            closeAllMenuItens();
        }

        // reference var
        nav_scrollInit = scrollBody;
    });
    $(window).on('load', function(event) {
        var scrollBody = $(this).scrollTop();
        if (scrollBody > 1) {
            nav_el.nav.addClass('scrolled');
        } else {
            nav_el.nav.removeClass('scrolled');
        }
    });

    // open/close/menus/submenus/hamburguer on clicks
    nav_el.hamburguer.on('click', function() {
        if ($(this).hasClass(nav_classActive)) {
            closeAllMenuItens();
        } else {
            openAllMenuItens();
        }
    });
    nav_el.mask.on('click', function() {
        closeAllMenuItens()
    });
    nav_el.liWithoutSubMenu.on('click', function() {
        closeAllMenuItens();
    });
    nav_el.firstSubMenu.children('li').on('click', function() {
        if(!$(this).hasClass('openSecondSubMenu')) {
            closeAllMenuItens();
        }
    });
    nav_el.secondSubMenu.children('li').on('click', function() {
        closeAllMenuItens();
    });
}
if ($('.l-nav--withSubMenus').length) {
    // open close submenus with clicks
    nav_el.liWithOneLevelSubMenu.on('click', function (event) {
        event.preventDefault();
        if (is.mobile()) {
            // mobile
            $(this).parent('li').toggleClass(nav_classActive);
            $(this).parent('li').children('a').toggleClass(nav_classActive);
            showMask();
        } else {
            // desktop
            nav_el.liWithOneLevelSubMenu.parent('li').removeClass(nav_classActive);
            nav_el.liWithTwoLevelsSubMenu.parent('li').removeClass(nav_classActive);
            $(this).parent('li').addClass(nav_classActive);
            showMask();
        }
    });
    nav_el.liWithTwoLevelsSubMenu.on('click', function (event) {
        event.preventDefault();
        if (is.mobile()) {
            // mobile
            $(this).parent('li').toggleClass(nav_classActive);
            $(this).parent('li').children('a').toggleClass(nav_classActive);
            showMask()
        } else {
            // desktop
            nav_el.liWithOneLevelSubMenu.parent('li').removeClass(nav_classActive);
            nav_el.liWithTwoLevelsSubMenu.parent('li').removeClass(nav_classActive);
            $(this).parent('li').addClass(nav_classActive);
            showMask()
        }
    });
    nav_el.openSecondSubMenu.on('click', function(event) {
        // event.preventDefault();
        if (is.mobile()) {
            $(this).children('.secondSubMenu').toggleClass(nav_classActive);
        } else {
            // desktop
            nav_el.secondSubMenu.removeClass(nav_classActive);
            $(this).children('.secondSubMenu').addClass(nav_classActive);
        }
    });
}

// modules
if ($('#w_ieDetect').length) {
    function showMessageOnIE(warnLevel) {
        // warnLevel = 1 -> Remover aviso
        // warnLevel = 2 -> Recolher aviso
        // warnLevel = 3 -> Bloquear navegação

        var ieDetectEl = $('#w_ieDetect');
        var ieDetectEl__mask = $('#w_ieDetect__mask');
        var ieDetectEl__unlock = $('.w_ieDetect__unlockSite');

        if (is.ie()) {
            console.log('IE DETECTED')
            if(warnLevel == 1) {
                $('body').css('overflow', 'hidden');
                ieDetectEl.removeClass('u-dnone').addClass('is-visible');
                ieDetectEl__mask.removeClass('u-dnone').addClass('is-visible');

                ieDetectEl__unlock.on('click', function() {
                    ieDetectEl.remove();
                    ieDetectEl__mask.remove();
                    $('body').css('overflow-y', 'auto');
                    $('body').css('overflow-x', 'hidden');
                });
            }
            if(warnLevel == 2) {
                //block overflow and show modal
                $('body').css('overflow', 'hidden');
                ieDetectEl.removeClass('u-dnone').addClass('is-visible');
                ieDetectEl__mask.removeClass('u-dnone').addClass('is-visible');

                // hide modal and mask
                ieDetectEl__unlock.on('click', function() {
                    $(this).remove();
                    ieDetectEl__mask.remove();
                    ieDetectEl.removeClass('is-visible');
                    ieDetectEl.addClass('is-fixed');
                    $('body').css('overflow-y', 'auto');
                    $('body').css('overflow-x', 'hidden');
                });
            }
            if(warnLevel == 3) {
                $('nav').remove();
                $('header').remove();
                $('footer').remove();
                $('main').remove();
                ieDetectEl__unlock.remove();
                $('body').css('overflow', 'hidden');
                ieDetectEl.removeClass('u-dnone').addClass('is-visible');
                ieDetectEl__mask.removeClass('u-dnone').addClass('is-visible');
            }
        } else {
            ieDetectEl.remove();
            ieDetectEl__mask.remove();
        }
    }
    $(window).on('load', showMessageOnIE(3));
}
if ($('.js-whatsLink').length) {
    var number = $('.js-whatsLink').attr('data-whatsNumber');
    var wppEl = $('.js-whatsLink');

    // this var have an options and parameters of the link
    var wppl__parts = {
        link_mobile: 'http://api.whatsapp.com/',
        link_web: 'https://web.whatsapp.com/',
        phone: 'send?phone=',
        msg: 'text='
    };

    // make the final link
    wppEl.on('click', function() {
        if (is.iphone() || is.androidPhone() || is.windowsPhone() || is.blackberry() || is.mobile()) {
            // MOBILE VERSION
            window.open(wppl__parts.link_mobile + wppl__parts.phone + number, '_blank');
        } else {
            window.open(wppl__parts.link_web + wppl__parts.phone + number, '_blank');
        }
    });
}

// content modal
function closeModal() {
    $('.u-contentMask').removeClass('is-active');
    $('.contentInModal').removeClass('is-active');
    $('body').removeClass('u-overflowBlocked');
}
function openCadastro() {
    $('.u-contentMask').addClass('is-active');
    $('#cadastro').addClass('is-active');
    $('body').addClass('u-overflowBlocked');
}
function openCadastroLoja() {
    $('.u-contentMask').addClass('is-active');
    $('#cadastro-lojista').addClass('is-active');
    $('body').addClass('u-overflowBlocked');
}
function openRecSenha() {
    $('.u-contentMask').addClass('is-active');
    $('#recuperar-senha').addClass('is-active');
    $('body').addClass('u-overflowBlocked');
}
function openAltSenha() {
    $('.u-contentMask').addClass('is-active');
    $('#alterar-senha').addClass('is-active');
    $('body').addClass('u-overflowBlocked');
}
function openObrigado() {
    $('.u-contentMask').addClass('is-active');
    $('#view-obrigado').addClass('is-active');
    $('body').addClass('u-overflowBlocked');
}
function openReconfirma() {
    $('.u-contentMask').addClass('is-active');
    $('#view-reconfirma').addClass('is-active');
    $('body').addClass('u-overflowBlocked');
}
function openNFDetails(nota) {
    $('.u-contentMask').addClass('is-active');
    $('#detalhes-nota').addClass('is-active');
    $('body').addClass('u-overflowBlocked');
    $("#detalhes-nota #loadContentNF").html('');
    $('#detalhes-nota #loaderNota').removeClass('u-dnone');
    $.ajax({
        type: "POST",
        data: {nota: nota},
        url: "detalhe-nf",
        success: function (result) {
            $('#detalhes-nota #loaderNota').addClass('u-dnone');
            $("#detalhes-nota #loadContentNF").html(result);
        }
    });
}
function openAcaoDetails(acao) {
    $('.u-contentMask').addClass('is-active');
    $('#detalhes-acao').addClass('is-active');
    $('body').addClass('u-overflowBlocked');
    $("#detalhes-acao #loadContentAcao").html('');
    $('#detalhes-acao #loaderAcao').removeClass('u-dnone');
    $.ajax({
        type: "POST",
        data: {acao: acao},
        url: "detalhe-acao",
        success: function (result) {
            $('#detalhes-acao #loaderAcao').addClass('u-dnone');
            $("#detalhes-acao #loadContentAcao").html(result);
        }
    });
}
function openAcaoDetailsProfissionais(acao) {
    $('.u-contentMask').addClass('is-active');
    $('#detalhes-acao').addClass('is-active');
    $('body').addClass('u-overflowBlocked');
    $("#detalhes-acao #loadContentAcao").html('');
    $('#detalhes-acao #loaderAcao').removeClass('u-dnone');
    $.ajax({
        type: "POST",
        data: {acao: acao},
        url: "detalhe-acao-profissionais",
        success: function (result) {
            $('#detalhes-acao #loaderAcao').addClass('u-dnone');
            $("#detalhes-acao #loadContentAcao").html(result);
        }
    });
}
function openCadastroLojaConstrutora() {
    $('#formCadastroLoja__nome').val('');
    $('#formCadastroLoja__estado').val('');
    $('#formCadastroLoja__cidade').html('<option value="">'+__('Aguardando')+'</option>');
    $('.u-contentMask').addClass('is-active');
    $('#cadastroLoja').addClass('is-active');
    $('body').addClass('u-overflowBlocked');
}
function openCadastroProfissional() {
    $('#formCadProfissionais__nome').val('');
    $('#formCadProfissionais__telefone').val('');
    $('#formCadProfissionais__email').val('');
    $('#formCadProfissionais__estado').val('');
    $('#formCadProfissionais__cidade').html('<option value="">'+__('Aguardando')+'</option>');
    $('.u-contentMask').addClass('is-active');
    $('#cadastroProfissional').addClass('is-active');
    $('body').addClass('u-overflowBlocked');
}
function changePhotoForm(input) {
    if (input.files && input.files[0]) {
        var reader = new FileReader();
        reader.onload = function (e) {
            $('.picUser').attr('src', e.target.result).addClass('js-withTempImage');
        }
        reader.readAsDataURL(input.files[0]);
    }
}
function openConfirmaPermissao() {
    $('.u-contentMask').addClass('is-active');
    $('#confirma-permissao').addClass('is-active');
    $('body').addClass('u-overflowBlocked');
}

function openInfoProdutoFerramentasMKT(codigo) {
    $("#info-ferramenta-mkt .u-container").html('');
    $.ajax({
        type: "POST",
        data: {codigo: codigo},
        url: "load-detalhes-produto",
        success: function (result) {
            $("#info-ferramenta-mkt .u-container").html(result);
        }
    });

    $('.u-contentMask').addClass('is-active');
    $('#info-ferramenta-mkt').addClass('is-active');
    $('body').addClass('u-overflowBlocked');
}

function openRegulamentoAceite() {
    $('.u-contentMask').addClass('is-active');
    $('#regulamento-aceite').addClass('is-active');
    $('body').addClass('u-overflowBlocked');
}

function openRegulamento() {
    $('.u-contentMask').addClass('is-active');
    $('#regulamento').addClass('is-active');
    $('body').addClass('u-overflowBlocked');
}

if (get__hash() === '#cadastro') {
    openCadastro();
} else if (get__hash() === '#recuperar-senha') {
    openRecSenha();
} else if (get__hash() === '#alterar-senha') {
    openAltSenha();
} else if (get__hash() === '#obrigado') {
    openObrigado();
} else if (get__hash() === '#reconfirma') {
    openReconfirma();
} else if (get__hash() === '#cadastro-lojista') {
    openCadastroLoja();
} else if (get__hash() === '#permissao') {
    openConfirmaPermissao();
} else if (get__hash() === '#carrinho') {
    openCarrinhoFerramentasMKT();
} else if (get__hash() === '#info-ferramenta-mkt') {
    closeModal();
} else if (get__hash() === '#regulamento-aceite') {
    openRegulamentoAceite();
} else if (get__hash() === '#regulamento') {
    openRegulamento();
}

$('.js-openInfoFerramentaMKT').on('click', function(e) {
    e.preventDefault();
    var codigo = $(this).attr('data-codigo');
    openInfoProdutoFerramentasMKT(codigo);
});
$('.js-openCadastroLojista').on('click', function (event) {
    event.preventDefault();
    openCadastroLoja()
});
$('.js-openCadastro').on('click', function() {openCadastro()});
$('.js-openRecSenha').on('click', function() {openRecSenha()});
$('.js-openNFDetails').on('click', function() {openNFDetails($(this).attr('data-nf'))});
$('.js-openAcaoDetails').on('click', function() {openAcaoDetails($(this).attr('data-acao'))});
$('.js-openAcaoDetailsProfissionais').on('click', function() {openAcaoDetailsProfissionais($(this).attr('data-acao'))});
$('.u-contentMask').on('click', function() {closeModal()});
$('.closeModal').on('click', function() {closeModal()});

// IS IMAGE
function isImage(id){
    var file = document.getElementById(id);
    file = (file!=null && file!=undefined) ? file.files[0] : false;

    if (file) {
        var tipo = file.type.split('/');
        var ext = tipo[1].toLowerCase();

        if (ext === 'jpeg' || ext === 'jpg' || ext === 'png' || ext === 'pdf') {
            return true;
        } else {
            return false;
        }
        //console.log("Nome: " + file.name + " <br />Type: " + file.type + "<br />Tamanho: " + file.size);
    }
    return true;
}

// fancybox images
$('[data-fancybox]').fancybox({
    buttons: [
        //"zoom",
        //"share",
        //"slideShow",
        //"fullScreen",
        "download",
        //"thumbs",
        "close"
    ],
});

// general input masks
if (is.not.ie()) {
    $('.cepMask').mask("99999-999");
    $('.cpfMask').mask("999.999.999-99");
    $('.cnpjMask').mask("99.999.999/9999-99");
    $('.dataMask').mask("99/99/9999");
    $('.foneMask').focusout(function () {
        var phone;
        $('.foneMask').unmask();
        phone = $('.foneMask').val().replace(/\D/g, '');
        if (phone.length > 10) {
            $('.foneMask').mask("(99) 99999-999?9");
        } else {
            $('.foneMask').mask("(99) 9999-9999?9");
        }
    }).trigger('focusout');
    $('.maskDecimal').maskMoney({
        thousands: '.',
        decimal : ','
    });
    $('.dataOnlyNumber').bind('keypress', function (event) {
        var regex = new RegExp("^[0-9]+$");
        var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
        if (!regex.test(key)) {
            event.preventDefault();
            return false;
        }
    });
}

// forms
function validaCPF(CPF) {
    var erro = 0;
    var Soma;
    var Resto;
    var strCPF = CPF.replace(".", ""); //tira ponto
    strCPF = strCPF.replace(".", ""); //tira o segundo ponto
    strCPF = strCPF.replace("-", ""); //tira hífen
    Soma = 0;
    if (strCPF == "00000000000") erro = 1;
    for (i = 1; i <= 9; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
    Resto = (Soma * 10) % 11;
    if ((Resto == 10) || (Resto == 11)) Resto = 0;
    if (Resto != parseInt(strCPF.substring(9, 10))) erro = 1;
    Soma = 0;
    for (i = 1; i <= 10; i++)
        Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
    Resto = (Soma * 10) % 11;
    if ((Resto == 10) || (Resto == 11)) Resto = 0;
    if (Resto != parseInt(strCPF.substring(10, 11))) erro = 1;
    if (erro == 0) {
        return true;
    } else {
        return false;
    }
}
function validaCNPJ(cnpj) {
    cnpj = cnpj.replace(/[^\d]+/g, '');
    if (cnpj == '') return false;
    if (cnpj.length != 14)
        return false;
    // Elimina CNPJs invalidos conhecidos
    if (cnpj == "00000000000000" ||
        cnpj == "11111111111111" ||
        cnpj == "22222222222222" ||
        cnpj == "33333333333333" ||
        cnpj == "44444444444444" ||
        cnpj == "55555555555555" ||
        cnpj == "66666666666666" ||
        cnpj == "77777777777777" ||
        cnpj == "88888888888888" ||
        cnpj == "99999999999999")
        return false;
    // Valida DVs
    tamanho = cnpj.length - 2
    numeros = cnpj.substring(0, tamanho);
    digitos = cnpj.substring(tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2)
            pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(0))
        return false;
    tamanho = tamanho + 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2)
            pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(1))
        return false;
    return true;
}


if ($('.formAlteraSenha').length) {
    $(".formAlteraSenha").validate({
        rules: {
            alter__senha: "required",
            alter__senha2: {
                equalTo: "#alter__senha"
            }
        },
        submitHandler: function (form) {

            //SUBMIT form
            $(form).ajaxSubmit({
                //target: 'status-envio',
                beforeSubmit: function () {
                    $('.formAlteraSenha .c-stsSend').removeClass('u-dnone');
                    $('.formAlteraSenha .c-stsSend__feedback--load').removeClass('u-dnone');
                    $('.formAlteraSenha  #btnAlter').attr('disabled', true);
                },
                success: function (result) {
                    result = result.split('|');
                    if(parseInt(result[1]) == 1){
                        $('.formAlteraSenha .c-stsSend__feedback').addClass('u-dnone');
                        $('.formAlteraSenha .c-stsSend__feedback--success').removeClass('u-dnone');
                        $('.formAlteraSenha .c-stsSend__feedback--success span').html(result[2]);
                        setTimeout(function(){
                            if(result[3] === 'alt'){
                                $('.formAlteraSenha .c-stsSend').addClass('u-dnone');
                                $('.formAlteraSenha .c-stsSend__feedback').addClass('u-dnone');
                                $('.formAlteraSenha #btnAlter').attr('disabled', false);
                                $('.formAlteraSenha .fieldPass').val('');
                            }else{
                                window.location = result[4]+'login';
                            }
                        },5000);
                    }else{
                        $('.formAlteraSenha .c-stsSend__feedback').addClass('u-dnone');
                        $('.formAlteraSenha .c-stsSend__feedback--error').removeClass('u-dnone');
                        $('.formAlteraSenha .c-stsSend__feedback--error span').html(result[2]);
                        setTimeout(function () {
                            $('.formAlteraSenha .c-stsSend').addClass('u-dnone');
                            $('.formAlteraSenha .c-stsSend__feedback').addClass('u-dnone');
                            $('.formAlteraSenha #btnAlter').attr('disabled', false);
                        }, 3000);
                    }
                }
            });
        }
    });
}

if ($('.formAceiteRegulamento').length) {
    $(".formAceiteRegulamento").validate({
        submitHandler: function (form) {
            //SUBMIT form
            $(form).ajaxSubmit({
                beforeSubmit: function () {
                    $('.formAceiteRegulamento .c-stsSend').removeClass('u-dnone');
                    $('.formAceiteRegulamento .c-stsSend__feedback--load').removeClass('u-dnone');
                    $('.formAceiteRegulamento  #btn-aceite-regulamento').attr('disabled', true);
                },
                success: function (result) {
                    result = result.split('|');
                    if(parseInt(result[1]) == 1){
                        $('.formAceiteRegulamento .c-stsSend__feedback').addClass('u-dnone');
                        $('.formAceiteRegulamento .c-stsSend__feedback--success').removeClass('u-dnone');
                        $('.formAceiteRegulamento .c-stsSend__feedback--success span').html(result[2]);
                        setTimeout(function(){
                            window.location = result[4];
                        },3000);
                    }else{
                        $('.formAceiteRegulamento .c-stsSend__feedback').addClass('u-dnone');
                        $('.formAceiteRegulamento .c-stsSend__feedback--error').removeClass('u-dnone');
                        $('.formAceiteRegulamento .c-stsSend__feedback--error span').html(result[2]);
                        setTimeout(function () {
                            $('.formAceiteRegulamento .c-stsSend').addClass('u-dnone');
                            $('.formAceiteRegulamento .c-stsSend__feedback').addClass('u-dnone');
                            $('.formAceiteRegulamento #btn-aceite-regulamento').attr('disabled', false);
                        }, 3000);
                    }
                }
            });
        }
    });
}

if ($('.EditConta').length) {

    $('#formEditConta__modalidade').on('change',function(){
        var mode = $(this).val();

        if(mode === 'A'){
            $("span.opcional").show();
            $("span.opcional").show();

            $('#formEditConta__CNPJ').removeAttr('required','required').val('');
            $('#formEditConta__escritorio').removeAttr('required','required').val('');
        }else{
            $("span.opcional").hide();
            $("span.opcional").hide();
            $('#formEditConta__escritorio').attr('required','required');
            $('#formEditConta__CNPJ').attr('required','required');
        }
    });

    $(".EditConta").validate({
        submitHandler: function (form) {

            //SUBMIT form
            $(form).ajaxSubmit({
                //target: 'status-envio',
                beforeSubmit: function () {
                    $('.EditConta .c-stsSend').removeClass('u-dnone');
                    $('.EditConta .c-stsSend__feedback--load').removeClass('u-dnone');
                    $('.EditConta  .btnEdit').attr('disabled', true);
                },
                success: function (result) {
                    result = result.split('|');
                    if(parseInt(result[1]) == 1){
                        $('.EditConta .c-stsSend__feedback').addClass('u-dnone');
                        $('.EditConta .c-stsSend__feedback--success').removeClass('u-dnone');
                        $('.EditConta .c-stsSend__feedback--success span').html(result[2]);
                        setTimeout(function(){
                            location.href = 'conta';
                        },2000);
                    }else{
                        $('.EditConta .c-stsSend__feedback').addClass('u-dnone');
                        $('.EditConta .c-stsSend__feedback--error').removeClass('u-dnone');
                        $('.EditConta .c-stsSend__feedback--error span').html(result[2]);
                        setTimeout(function () {
                            $('.EditConta .c-stsSend').addClass('u-dnone');
                            $('.EditConta .c-stsSend__feedback').addClass('u-dnone');
                            $('.EditConta .btnEdit').attr('disabled', false);
                        }, 3000);
                    }
                }
            });
        }
    });
}

if ($('.EditContaLoja').length) {
    $(".EditContaLoja").validate({
        submitHandler: function (form) {

            //SUBMIT form
            $(form).ajaxSubmit({
                //target: 'status-envio',
                beforeSubmit: function () {
                    $('.EditContaLoja .c-stsSend').removeClass('u-dnone');
                    $('.EditContaLoja .c-stsSend__feedback--load').removeClass('u-dnone');
                    $('.EditContaLoja  .btnEdit').attr('disabled', true);
                },
                success: function (result) {
                    result = result.split('|');
                    if(parseInt(result[1]) == 1){
                        $('.EditContaLoja .c-stsSend__feedback').addClass('u-dnone');
                        $('.EditContaLoja .c-stsSend__feedback--success').removeClass('u-dnone');
                        $('.EditContaLoja .c-stsSend__feedback--success span').html(result[2]);
                        setTimeout(function(){
                            location.href = 'loja/conta';
                        },2000);
                    }else{
                        $('.EditContaLoja .c-stsSend__feedback').addClass('u-dnone');
                        $('.EditContaLoja .c-stsSend__feedback--error').removeClass('u-dnone');
                        $('.EditContaLoja .c-stsSend__feedback--error span').html(result[2]);
                        setTimeout(function () {
                            $('.EditContaLoja .c-stsSend').addClass('u-dnone');
                            $('.EditContaLoja .c-stsSend__feedback').addClass('u-dnone');
                            $('.EditContaLoja .btnEdit').attr('disabled', false);
                        }, 3000);
                    }
                }
            });
        }
    });
}

if ($('.EditSociais').length) {
    $(".EditSociais").validate({
        submitHandler: function (form) {
            //SUBMIT form
            $(form).ajaxSubmit({
                //target: 'status-envio',
                beforeSubmit: function () {
                    $('.EditSociais .c-stsSend').removeClass('u-dnone');
                    $('.EditSociais .c-stsSend__feedback--load').removeClass('u-dnone');
                    $('.EditSociais  .btnEdit').attr('disabled', true);
                },
                success: function (result) {
                    result = result.split('|');
                    if(parseInt(result[1]) == 1){
                        $('.EditSociais .c-stsSend__feedback').addClass('u-dnone');
                        $('.EditSociais .c-stsSend__feedback--success').removeClass('u-dnone');
                        $('.EditSociais .c-stsSend__feedback--success span').html(result[2]);
                        setTimeout(function(){
                            location.href = 'conta';
                        },2000);
                    }else{
                        $('.EditSociais .c-stsSend__feedback').addClass('u-dnone');
                        $('.EditSociais .c-stsSend__feedback--error').removeClass('u-dnone');
                        $('.EditSociais .c-stsSend__feedback--error span').html(result[2]);
                        setTimeout(function () {
                            $('.EditSociais .c-stsSend').addClass('u-dnone');
                            $('.EditSociais .c-stsSend__feedback').addClass('u-dnone');
                            $('.EditSociais .btnEdit').attr('disabled', false);
                        }, 3000);
                    }
                }
            });
        }
    });
}

$(document).on('change','.cad_estado',function(){
    var uf = $(this).val();
    var code = ($(this).attr('data-code')=='N' ? $(this).attr('data-code') : 'S');

    $(".cad_cidade").html('<option value="">Carregando cidades...</option>');
    $.ajax({
        type: "POST",
        data: {uf: uf, code: code},
        url: "ajax-cidades.php",
        success: function (result) {
            $(".cad_cidade").html(result);

            if ($('.cad_cidade').hasClass('autoFillCidade')) {
                var nomeCidade = $(".autoFillCidade").attr('data-cidade');
                $('.autoFillCidade option:contains("'+nomeCidade+'")').prop("selected", true);
            }
        }
    });
});

$('#excluiConta').on('click', function() {
    var code = $(this).attr('data-codigo');
    Swal.fire({
        title: __('Tem certeza que vai excluir a sua conta?'),
        text: __('Todos os seus dados serão deletados! Esta ação é irreversível!'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3e3e3e',
        cancelButtonColor: '#d33',
        confirmButtonText: __('Sim, quero excluir!')
    }).then(function(result) {
        if (result.value) {
            location.href = 'logout?exc='+code;
        }
    });
});

$('#desativaConta').on('click', function() {
    var code = $(this).attr('data-codigo');
    Swal.fire({
        title: __('Deseja mesmo desativar a sua conta?'),
        text: __('Caso queira retornar ao programa, terá que solicitar a reativação do seu cadastro ao administrador do sistema.'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3e3e3e',
        cancelButtonColor: '#d33',
        confirmButtonText: __('Sim, quero desativar!')
    }).then(function(result) {
        if (result.value) {
            location.href = 'logout?des='+code;
        }
    });
});

//marca notificacao como lida
$(document).on('click','.newNotifications .c-pendencies__card a',function(){
    var notificacao = $(this).attr('data-codigo');
    var link = $(this).attr('data-link');
    var url = $(this).attr('href');
    $.ajax({
        type: "POST",
        data: { notificacao: notificacao, tipo : 'readed' },
        url: "read-notificacao",
        success: function (result) {
            if (link=='S')
                location.href = url;
            else
                $(".newNotifications .notificacao"+notificacao).remove();

            if ($('.l-notifications ul.newNotifications li').length == 0) {
                $('.icon-notification span').remove();
                $('.l-notifications ul').html('<span>'+result+'</span>');
            }
        }
    });
});

//remove notificacao
$(document).on('click','.allNotifications .c-pendencies__card a',function(){
    var notificacao = $(this).attr('data-codigo');
    var link = $(this).attr('data-link');
    var url = $(this).attr('href');
    $.ajax({
        type: "POST",
        data: { notificacao: notificacao, tipo : 'removed' },
        url: "read-notificacao",
        success: function (result) {
            if (link=='S')
                location.href = url;
            else
                $(".notificacao"+notificacao).remove();

            if ($('.l-notifications ul li').length == 0) {
                $('.icon-notification span').remove();
                $('.l-notifications ul').html('<span>'+result+'</span>');
            }
        }
    });
});

$(document).ready(function() {

    function limpa_formulario_cep() {
        // Limpa valores do formulário de cep.
        $(".autoFillEndereco").val("");
        $(".autoFillBairro").val("");
        $(".autoFillCidade").val("");
        $(".autoFillEstado").val("");
        //$("#ibge").val("");
    }

    function formCepReadyOnly(value) {
        $(".autoFillEndereco").prop('readonly', value);
        $(".autoFillBairro").prop('readonly', value);
        $(".autoFillCidade").prop('readonly', value);
        $(".autoFillEstado").prop('readonly', value);
        $(".autoFillNumero").prop('readonly', value);
        $(".autoFillComplemento").prop('readonly', value);
    }

    //Quando o campo cep perde o foco.
    $(".autoFillCEP").blur(function() {
        if ($('#formCadastroStep1__pais').val()=='BR' || $('#formEndosso_pais').val()=='BR') {
            openLoading();
            //Nova variável "cep" somente com dígitos.
            var cep = $(this).val().replace(/\D/g, '');

            //Verifica se campo cep possui valor informado.
            if (cep != "") {

                formCepReadyOnly(true);

                //Expressão regular para validar o CEP.
                var validacep = /^[0-9]{8}$/;

                //Valida o formato do CEP.
                if (validacep.test(cep)) {

                    //Preenche os campos com "..." enquanto consulta webservice.
                    $(".autoFillEndereco").val("...");
                    $(".autoFillBairro").val("...");
                    $(".autoFillCidade").val("...");
                    $(".autoFillEstado").val("...");

                    //Consulta o webservice viacep.com.br/
                    $.getJSON("https://viacep.com.br/ws/" + cep + "/json/?callback=?", function (dados) {

                        if (!("erro" in dados)) {
                            //Atualiza os campos com os valores da consulta.
                            $(".autoFillEndereco").val(dados.logradouro);
                            $(".autoFillBairro").val(dados.bairro);
                            //$(".autoFillCidade").val(dados.localidade);
                            $(".autoFillCidade").attr('data-cidade', dados.localidade);
                            $(".autoFillEstado").val(dados.uf);
                            $(".autoFillEstado").change();
                            formCepReadyOnly(false);
                            closeLoading();
                            $(".fillCEP").toggleClass('active');
                        } //end if.
                        else {
                            closeLoading();
                            //CEP pesquisado não foi encontrado.
                            limpa_formulario_cep();
                            formCepReadyOnly(false);
                            alert();
                            Swal.fire({
                                title: __('CEP não encontrado.'),
                                icon: 'warning',
                                showCancelButton: false,
                                confirmButtonColor: '#1c2f33',
                                cancelButtonColor: '#d33',
                                confirmButtonText: 'OK'
                            });
                            $(".fillCEP").toggleClass('active');
                        }
                    });
                } //end if.
                else {
                    closeLoading();
                    //cep é inválido.
                    limpa_formulario_cep();
                    formCepReadyOnly(false);
                    alert(__('Formato de CEP inválido.'));
                }
            } //end if.
            else {
                closeLoading();
                //cep sem valor, limpa formulário.
                limpa_formulario_cep();
                formCepReadyOnly(false);
            }
        }
    });
});

/**
 * CARREGANDO : Aguarde ...
 */
function openLoading() {
    $("#divCarregando").show();
}
function closeLoading() {
    $("#divCarregando").hide();
}

$(window).on('load', function() {
    // Quando a página estiver totalmente carregada, remove o id
    closeLoading();
});

if ($('.popupBanner').length > 0) {
    Swal.fire({
        imageUrl: $('.popupBanner').attr('data-imagem'),
        padding: 0,
        width: 'auto',
        heightAuto: true,
        imageWidth: 600,
        closeButtonColor: 'green',
        showCloseButton: true,
        showCancelButton: false,
        imageHeight: 'auto',
        showConfirmButton: false,
        customClass: {
            image: 'u-noMargin',
          }
    });
}